import { homecontentsBrandcodes } from '../../constants';

export const footerDisclaimer = ({ fsgUrl, termsOfUseUrl }) => {
    return `<p>We recommend you read the Product Disclosure Statement (PDS) before you make a decision.</p>
    <p>Please note that when we display quotes on our comparison results page, they're indicative only and subject to change based on further questions by the insurer.</p>
    <p>This webpage is hosted and managed by Compare the Market Pty Ltd ACN 117 323 378 AFSL 422926 (CTM) on behalf of Choosi Pty Ltd ABN 15 147 630 886; AFSL 402397 (Choosi).</p>
    <p>We don't compare all home and contents insurers or products in the market or all products offered by all brands.
     Information on this website is general and doesn't take into account your personal objectives, financial situation, or needs.
     You should consider the relevant Product Disclosure Statement (PDS) for more information before deciding to purchase a product to ensure the product suits your needs.</p>
    <p>For more information about the range of insurers and products we compare, how our service works,
     and how we make our money (remembering that the service is free for you to use),
     read the <a target="_blank" href="${termsOfUseUrl}">Website Terms and Conditions</a>
     and <a href="${fsgUrl}" target="_blank">Financial Services Guide</a>.</p>
     <p>CTM is a related entity of Auto & General Services Pty Ltd, the issuer of some products available through CTM.</p>`;
};

// no trusted partner modal in Choosi
export const trustedPartnerContent = () => {
    const trustedPartnerConfig = {
        title: '',
        description: '',
        reasons: [],
        disclaimer: ''
    };
    return trustedPartnerConfig;
};

export const redbookDisclosureContent = () => {
    const redbookDisclosureConfig = {
        title: '',
        description: ''
    };
    return redbookDisclosureConfig;
};

export const partnerBrands = () => [
    homecontentsBrandcodes.BUDD,
    // homecontentsBrandcodes.WOOL
    // homecontentsBrandcodes.VIRG
];

export const crossSellOtherVerticalsOnResults = () => false;
export const spinnerColour = () => '#FE5A19';
export const showNoResultsOverlayGenericMessage = () => true;
export const resultsScreenDefaultDisplayMode = () => 'row';

export const contactDetailOptInPrivacyMessage = ({ companyName, termsOfUseUrl, fsgUrl, privacyPolicyUrl }) => {
    return `I have received and accept the
    <a href="${termsOfUseUrl}" target="_blank" data-id="websiteTermsOfUseFooterLink">Website Terms of Use</a>, 
    <a href="${fsgUrl}" target="_blank" data-id="financialServicesGuideLink">Financial Services Guide</a> and
    <a href="${privacyPolicyUrl}" target="_blank" data-id="websitePrivacyPolicyFormTermsLink">Privacy Policy</a>.
    By providing a contact number, I invite ${companyName} and/or its trusted partners to call me to discuss the
    potential purchase of a product and I agree that ${companyName} may email, SMS or otherwise contact me
    about all products and services it provides.`;
};

export const enableResultsFeatureAccordion = () => false;
export const showPriceConfidenceBanner = () => false;
export const spinnerType = () => 'Default';
